import { EnvironmentProviders, inject, makeEnvironmentProviders, provideAppInitializer } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { firstValueFrom } from 'rxjs';
import { APP_SVG_ICONS } from './icons.constants';

const ICON_PRELOAD_CONCURRENCY = 4;

function preloadSvgIcons(iconRegistry: MatIconRegistry): void {
  const icons = [...APP_SVG_ICONS];

  const preloadNext = async (): Promise<void> => {
    const icon = icons.shift();
    if (!icon) {
      return;
    }

    try {
      await firstValueFrom(iconRegistry.getNamedSvgIcon(icon.name));
    } catch {
      // Best-effort preload; icons load on first use when the network is available.
    }

    await preloadNext();
  };

  void Promise.all(
    Array.from({ length: Math.min(ICON_PRELOAD_CONCURRENCY, icons.length) }, () => preloadNext()),
  );
}

export function provideIcons(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideAppInitializer(() => {
      const iconRegistry = inject(MatIconRegistry);
      const sanitizer = inject(DomSanitizer);

      for (const icon of APP_SVG_ICONS) {
        iconRegistry.addSvgIcon(
          icon.name,
          sanitizer.bypassSecurityTrustResourceUrl(`/icons/${icon.file}`),
        );
      }

      preloadSvgIcons(iconRegistry);
    }),
  ]);
}
